export const soapConnector = {
  authentication: {
    connectorActionGetRequests: "Get requests",
    connectorActionGetRequestsSuccess: "Get requests successfully",
    connectorActionGetRequestsError: "Get requests failed",
    connectorClass: "Connectorclass",
    connectorConfig_wsdl: "WSDL",
    testConnection: "Test connection",
    testConnectionSuccess: "Test connection successfully",
    testConnectionError: "Test connection failed"
  },
  output: {
    createResponseDataStructure: "Create DataStructure",
    createResponseDataStructureSuccess: "Create data structure successfully",
    createResponseDataStructureError: "Create data structure failed"
  },
  configuration: {
    connectorConfig_options: "Options",
    connectorConfig_optionsValues: {
      key: "Key",
      value: "Value"
    },
    createRequestDataStructure: "Create data structure",
    createRequestDataStructureSuccess: "Create data structure successfully",
    createRequestDataStructureError: "Create data structure failed",
    request: "Request"
  }
};
